<template>
    <div class="report-container">
        <h5 class="title">
            {{ $t('reports.dashboards.questionnairesAverage') }}
        </h5>
        <loader v-if="loading" :loader="loading" />
        <b-table
            v-if="!loading"
            responsive
            :items="items"
            :fields="fields"
            :bordered="true"
            :tbody-tr-class="rowClass"
        >
        </b-table>
        <div class="paginator-container">
            <b-pagination
                :disabled="loading"
                class="mb-0 align-self-center"
                :total-rows="pagination.total"
                :per-page="pagination.perPage"
                v-model="pagination.currentPage"
                @change="getQuestionnairesResults"
            />
        </div>
    </div>
</template>

<script>
import Loader from '@/views/components/loader'
import { formatNumber } from '@/lib/utils'
import { getQuestionnairesResults } from '@/views/reports/api'

export default {
    components: {
        Loader,
    },
    props: {
        filters: Object,
    },
    data() {
        return {
            items: [],
            pagination: {
                currentPage: 1,
                perPage: 10,
                total: null,
                lastPage: 1,
            },
            loading: false,
        }
    },
    computed: {
        fields() {
            return [
                { label: this.$t('values.questionnaire'), key: 'title' },
                {
                    label: this.$t('values.table.self'),
                    key: 'self',
                    class: 'text-center small-column',
                },
                {
                    label: this.$t('values.table.leader'),
                    key: 'leader',
                    class: 'text-center small-column',
                },
                {
                    label: this.$t('values.table.peer'),
                    key: 'peer',
                    class: 'text-center small-column',
                },
                {
                    label: this.$t('values.table.team'),
                    key: 'team',
                    class: 'text-center small-column',
                },
                {
                    label: this.$t('values.table.final'),
                    key: 'final',
                    class: 'text-center font-weight-bold small-column',
                },
            ]
        },
    },
    mounted() {
        this.getQuestionnairesResults()
    },
    watch: {
        filters() {
            this.getQuestionnairesResults()
        },
    },
    methods: {
        getQuestionnairesResults(page = 1) {
            this.loading = true
            getQuestionnairesResults(this.filters, page)
                .then(resp => {
                    this.pagination.currentPage = resp.current_page
                    this.pagination.perPage = resp.per_page
                    this.pagination.total = resp.total
                    this.pagination.lastPage = resp.lastPage
                    this.parseResults(resp.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        parseResults(data) {
            this.items = data.map(this.getResult)
        },
        getResult({ id, title, rating_score, networks_results }) {
            const { self, peer, team, leader } = networks_results
            return {
                id,
                title,
                final: this.getNumber(rating_score),
                self: this.getNumber(self ? self.rating_score : null),
                peer: this.getNumber(peer ? peer.rating_score : null),
                team: this.getNumber(team ? team.rating_score : null),
                leader: this.getNumber(leader ? leader.rating_score : null),
            }
        },
        getNumber(number) {
            return number != null ? formatNumber(number) : '-'
        },
        rowClass(item, type) {
            if (!item || type !== 'row') {
                return
            }

            if (item.id === 'total') {
                return 'table-grey'
            }
        },
    },
}
</script>

<style lang="sass" scoped>
@import './default_style'

.paginator-container
    display: flex
    justify-content: flex-end
    width: 100%

::v-deep
    .table-grey
        background-color: #E4E5E6
    .small-column
        width: 13%
    .page-item.active .page-link
        background-color: $darkBlue
        border-color: $darkBlue
    .page-link
        color: $darkBlue
</style>
